var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import { getAssetPath } from '@config/index';
import { DefaultLocale, getNavigatorLanguage, isValidLanguage, } from '@data/types/common';
import { languageToLocale, parseUrlLanguage, } from '@business/utils/language-locale';
/**
 * The language to start in, before the property model can say what the property
 * sells. The URL segment costs nothing, the navigator is the next best guess,
 * and `DataObserver` → `setLanguage` still overrides both with the property's
 * default — falling back to a supported language — once it loads.
 */
const resolveInitialLocale = () => {
    const language = parseUrlLanguage(window.location.pathname) || getNavigatorLanguage();
    return language ? languageToLocale(language) : DefaultLocale;
};
function doInitLocalizationService() {
    return __awaiter(this, void 0, void 0, function* () {
        const fallbackLng = DefaultLocale;
        const loadPath = `${getAssetPath()}/locales/{{lng}}.json`;
        const initialLocale = resolveInitialLocale();
        yield i18n
            .use(initReactI18next)
            .use(HttpApi)
            .init({
            backend: {
                allowMultiLoading: false,
                crossDomain: true,
                loadPath,
            },
            fallbackLng,
            interpolation: {
                escapeValue: false,
            },
            lng: initialLocale,
            load: 'currentOnly',
            lowerCaseLng: false,
            missingKeyHandler: (lng, ns, key) => {
                throw new Error(`Missing i18n key ${[lng].flat().join(',')}:${ns}:${key}`);
            },
            partialBundledLanguages: true,
            preload: [fallbackLng],
            saveMissing: false,
        });
    });
}
let initLocalizationPromise = null;
/**
 * Initializes i18next once, no matter how many callers race for it. Root gates
 * its first render on this (BENG-4245) so Root-level overlays render with real
 * translations, while DataObserver, the legal pages, the external payment page
 * and the date-picker webcomponents keep their own calls — they all share the
 * same underlying init. A failed init clears the memo so a later caller retries.
 */
export function initLocalizationService() {
    if (!initLocalizationPromise) {
        initLocalizationPromise = doInitLocalizationService().catch((error) => {
            initLocalizationPromise = null;
            throw error;
        });
    }
    return initLocalizationPromise;
}
export function changeLanguage(value) {
    return __awaiter(this, void 0, void 0, function* () {
        const localeValue = isValidLanguage(value) ? languageToLocale(value) : value;
        return i18n.changeLanguage(localeValue);
    });
}
export const t = i18n.t.bind(i18n);
export { i18n };
